import { Box, Chip, styled, Typography } from '@mui/material'
import { FC } from 'react'
import LinkAltIcon from '../../../../assets/icons/LinkAlt.svg?react'

export const StyledImage = styled('img')(() => ({
    width: '215px',
    height: '150px',
    borderRadius: '24px',
    objectFit: 'contain',
}))

export const StyledLink = styled('a')(() => ({
    textDecoration: 'none',
    display: 'flex',
    width: 'min-content',
}))

interface Props {
    title: string
    image: string
    price: string
    link: string
    source: string
}

const GoodsItem: FC<Partial<Props>> = ({ title, image, price, link = '', source }) => {
    return (
        <StyledLink href={link} target="_blank">
            <Box
                sx={{
                    border: '1px solid #F4F4F6',
                    borderRadius: '24px',
                    padding: '4px',
                    width: '240px',
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                {image ? (
                    <Box
                        sx={{
                            width: '231px',
                            height: '166px',
                            borderRadius: '24px',
                            padding: '8px',
                            display: 'inline-block',
                        }}>
                        <StyledImage src={image} />
                    </Box>
                ) : null}
                <Box
                    sx={{
                        padding: '12px',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                    <Typography marginBottom="4px" variant="h5">
                        {title}
                    </Typography>
                    <Typography variant="body2">{price}</Typography>
                    <Chip
                        size="small"
                        sx={{
                            '& .MuiChip-label': {
                                marginRight: '0',
                            },
                            marginRight: 'auto',
                            marginTop: '12px',
                        }}
                        label={
                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: '4px',
                                    alignItems: 'center',
                                }}>
                                <LinkAltIcon />
                                <Typography
                                    sx={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 1,
                                        WebkitBoxOrient: 'vertical',
                                        wordBreak: 'break-all',
                                        maxWidth: '200px',
                                    }}
                                    color="#5A5F72"
                                    variant="body2">
                                    {source}
                                </Typography>
                            </Box>
                        }
                    />
                </Box>
            </Box>
        </StyledLink>
    )
}

export default GoodsItem
